export default __webpack_public_path__ + "898225e.png";